/**
 * Self-contained build-time feature flag for the SEGMENT WALLPAPER surface — the
 * content-area background BEHIND the content blocks inside the OPEN segment
 * (SegmentView content area).
 *
 * Segment Wallpaper is a SEPARATE control from Segment Fill (wedge + behind-title)
 * — the two are NEVER merged (SEGMENT-FILL-DESIGN-MODEL.md, locked 2026-07-16). In
 * Gordon's live example the wallpaper is White.
 *
 * WHY ITS OWN FILE (mirrors segmentFillTitleFlag.js, segmentArcFillsFlag.js,
 * SegmentReactions/featureFlag.js): kept local so this render surface can be
 * reviewed / merged / rolled out INDEPENDENTLY of the fill flags. Defaults OFF;
 * flipped per environment via REACT_APP_SEGMENT_WALLPAPER.
 *
 * When OFF, SegmentView's content-area background is BYTE-IDENTICAL to today: no
 * dedicated wallpaper layer is rendered and the existing currentBg paths (including
 * the EW-003 arc-fill-model open layer for currentBg===2) are untouched.
 *
 * When ON, SegmentView paints a dedicated, Fill-INDEPENDENT wallpaper layer behind
 * the content (resolveSegmentWallpaper → White by default), and the content-area
 * IMAGE background (currentBg===2) is resolved from the WALLPAPER field
 * (bgWallpaper via BackgroundImageCover) rather than the Fill MODEL — so the
 * content surface is provably the Wallpaper, never the Fill.
 *
 * Flag-name collision audit: REACT_APP_SEGMENT_WALLPAPER is a new, unique name — no
 * existing REACT_APP_* var uses the SEGMENT_WALLPAPER token.
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const SEGMENT_WALLPAPER_ENABLED = truthy(
  process.env.REACT_APP_SEGMENT_WALLPAPER
);
